// Formaterar ett ISO-datum (YYYY-MM-DD) till synligt svenskt granskningsdatum.
// Används tillsammans med lastmodFor() så synligt datum = sitemapens lastmod.
export function formatReviewed(iso: string): string {
  const d = new Date(`${iso.slice(0, 10)}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat("sv-SE", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  }).format(d);
}
